<template>
  <v-row :class="['py-0 py-sm-2 settings-field']" no-gutters>
    <v-col
      cols="12"
      :sm="_includes(['gallery'], field.type) ? 12 : 8"
      class="pt-2 px-0 px-sm-3 pl-sm-0"
      order="2"
      order-sm="1"
    >
      <v-form v-model="isValid" @submit.prevent="$emit('save')">
        <v-text-field
          ref="field"
          outlined
          :label="label"
          dense
          :value="fieldVal"
          @input="save($event)"
          :rules="rules"
          :loading="saving"
        />
      </v-form>
    </v-col>
    <v-col
      v-if="isShowingCustomHint"
      cols="12"
      :sm="_includes(['gallery'], field.type) ? 12 : 4"
      :class="['hint text-body-1', { border: !_includes(['xs', 'sm'], $mq) }]"
      order="1"
      order-sm="2"
    >
      {{ field.hint }}
    </v-col>
    <v-col cols="12" v-if="$mq === 'xs' && field.type !== 'sectionTitle'">
      <v-divider class="my-2" />
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SanitizeHtml from 'sanitize-html'
import _isEqual from 'lodash/isEqual'
import _get from 'lodash/get'
import _includes from 'lodash/includes'
import debounce from 'debounce'
import ValidationRules from '@/constants/ValidationRules'

export default {
  name: 'ShopAccountField',
  props: {
    field: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  components: {},
  computed: {
    ...mapGetters('auth', ['getAuthUser']),
    rules() {
      let rules = this.field.rules
        ? this.field.rules
            .filter((ruleName) => ValidationRules[ruleName])
            .map((ruleName) =>
              ValidationRules[ruleName] ? ValidationRules[ruleName] : () => true
            )
        : []
      return rules
    },
    isShowingCustomHint() {
      return this.field.hint
    },
    isDirty() {
      let { stagedChanges, original } = this
      let isDirty = false
      if (Array.isArray(stagedChanges) || Array.isArray(original)) {
        isDirty = !_isEqual(stagedChanges, original)
      } else {
        isDirty =
          typeof stagedChanges !== 'undefined' && stagedChanges !== original
      }

      return isDirty
    }, // isDirty

    label() {
      return this.field.label
    }, // label

    fieldVal() {
      return _get(this.getAuthUser, this.field.name, '')
    },
  },
  data() {
    return {
      saving: false,
      isValid: false,
      stagedChanges: undefined,
      original: undefined,
    }
  },
  async created() {
    this.original = await _get(this.getAuthUser, this.field.name)
  },
  methods: {
    ...mapActions('shop', ['updateSetting']),

    save: debounce(async function(val) {
      if (this.$refs.field) {
        await this.$refs.field.validate()
      }

      if (!this.isValid) {
        return false
      }

      this.stagedChanges = val
    }, 250), // saveChanges
    _includes,
  }, //methods
  watch: {
    isDirty(isDirty) {
      if (isDirty) {
        this.$emit('dirtied', SanitizeHtml(this.stagedChanges))
      } else {
        this.$emit('cleaned')
      }
    },
    stagedChanges(stagedChanges) {
      this.$emit('update', SanitizeHtml(stagedChanges))
    },
    fieldVal() {
      this.original = _get(this.getAuthUser, this.field.name)
    },
  },
}
</script>

<style lang="scss">
.settings-field {
  .hint {
    margin-bottom: 8px;
    white-space: pre-line;
    &.border {
      padding: 12px;
      border-left: 1px solid #e6e6e6;
    }
  }
  .v-input--checkbox {
    .v-messages__message {
      margin-top: 4px;
      margin-bottom: 4px;
      font-size: 1rem;
      line-height: 1.3;
    }
  }
}
</style>
